module.exports = __webpack_public_path__ + "img/Modernisme_Bildekunst6.a9ac34a3.jpg";